<template>
  <div class="app">
    <!--
    <div class="web_familySite">
      <nav>
        <li><a href=""></a></li>
      </nav>
    </div>
    -->
    <div class="appCont">

      <div class="web_chorock">
        <div class="innerWeb">
          <div class="title">
            <img class="logo" src="@/assets/images/common/tigers.png" alt="">
          </div>
          <div class="btm">
            <a href="https://www.instagram.com/kiatigers_teamstore/" target="_blank"><img src="@/assets/images/main/insta_link.png"/></a>
            <a href="http://www.tigers.co.kr" target="_blank"><img src="@/assets/images/main/web_link.png"/></a>
          </div>

          <!--
          <div class="event" v-if="isBanner">
            <h3>팀스토어 이벤트</h3>
            <swiper class="swiper" :options="bannerOption">
              <swiper-slide v-for="(item, idx) in bannerData" :key="idx" class="swiper-slide">
                <a :href="item.landingUrl" class="swiperBox">
                  <img :src="item.imageUrl" alt="배너 이미지"/>
                </a>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          -->
        </div>
      </div>

      <div class="appWrapper">
        <div class="appInner">
          <Header/>
          <div class="contenst">
            <router-view />
          </div>
          <Footer />
        </div>
      </div>
    </div>

    <!--<iframe id="iframe_connect" src="https://tigers.co.kr/loginBridge.html" frameborder="0" width="1px" height="1px" style="position: absolute; top: -9999px; left: -999px;"></iframe>-->

  </div>
</template>

<script>
import Header from '@/views/Header';
import Footer from '@/views/Footer';
//import http from "@/api";
import shopByhttp from "@/api/shopBy";
import boardConf from '@/common/board'
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
export default {
  name: 'App',
  components:{
    Header,
    Footer,
    // Swiper,
    // SwiperSlide,
  },
  computed: {
    isBanner () {
      return this.bannerData.length > 0
    },
    isLogin () {
      return this.$store.getters['isLogin']
    }
  },
  data(){
    return {
      eventBannerCode: boardConf.eventBannerCode,
      bannerData: [],
      bannerOption: {
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
    }
  },
  created() {
    this.$store.dispatch('getCategory')
    this.getEventBanner()

    /*
    // 기아 홈페이지 로그인 처리
    const loginState = this.isLogin
    const _store = this.$store

    window.onmessage = function(e) {
      if (e.origin !== "https://tigers.co.kr") {
        return
      }

      const data = JSON.parse(e.data)
      const payload = JSON.parse(data.data);
      if (loginState || !payload || !payload.access) {
        return false
      } else {
        // 로그아웃상태, 토큰있음
        const args = { token: payload.access, agent: 'shop' };
        http.post('/user/conversion_token', args)
            .then(() => {
              const token = payload.access
              shopByhttp.get(`/oauth/openid?provider=ncpstore&openAccessToken=${token}`).then((res) => {
                let shopbyPayload = res.data
                shopbyPayload.state = true
                _store.commit('login', shopbyPayload)

                localStorage.setItem('kia_token', JSON.stringify(payload));
              }).catch((err) => {
                console.log(err)
              })
            })
            .catch(err => {
              console.log('ERROR', err)
            })
      }
    };
    */
  },
  mounted() {
    /*
    window.onload = function() {
      document.getElementById( "iframe_connect" ).contentWindow.postMessage( "getAccessToken", "*" )
    }
    */
  },
  methods: {
    async getEventBanner() {
      const banner = await shopByhttp.get(`/display/banners/${this.eventBannerCode}`)
      if(banner.data.length > 0){
        banner.data[0].accounts.forEach(el=> {
          this.bannerData.push(el.banners[0]);
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/styles/constants/breakpoints.scss';
  @import '@/assets/styles/constants/typography.scss';
  @import '@/assets/styles/constants/colors.scss';
  .app {
    min-height: 800px;
    //height: 100%;
    position: relative;
    background: $gray-f5;
    overflow-x: auto;
    background: url('@/assets/images/main/main_bg.png') no-repeat center top;
    background-size: cover;
    background-attachment: fixed;

    .appCont {
      max-width: 1040px;
      height: 100%;
      margin: 0 auto;

      >div {
        display: inline-block;
        vertical-align: top;
      }
      .web_chorock {
        width: 100%;
        max-width: 520px;
        height: 100%;
        padding: 0 60px;
        color: $midBlack;

        .innerWeb {
          position: fixed;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100vh;
          left: 50%;
          margin-left: -370px;
        }

        .btm {
          position: absolute;
          bottom: 12%;
          a {
            display: block;
            margin-bottom: 5px;
            img {
              max-height: 20px;
            }
          }
        }

        .table {
          position: fixed;
          top: 50%;
          transform: translateY(-50%);
          margin-left: 38px;
          .tableCell {
            width: 100%;
            text-align: center;
          }
        }
        .logo {
          max-width: 240px;
        }
        .txt{
          color: $gray-58;
          font-size: 20px;
          margin-top: 25px;
        }
        .title {
          font-size: 32px;
          margin-top: 10px;
          font-weight: 600;
          color: $midBlack;
        }

        .event {
          position: relative;
          margin-top: 50px;
          padding-bottom: 30px;
          overflow: hidden;

          h3 {
            font-weight: 600;
            color: $gray-58;
            font-size: 18px;
            text-align: left;
            padding-bottom: 10px;
          }
          .swiper {
            overflow: visible;
            .swiper-slide {
              border-radius: 20px;
              overflow: hidden;
            }
            .swiper-pagination {
              position: absolute;
              left: 50%;
              bottom: -30px;
              background-color: transparent;
              -webkit-transform: translateX(-50%);
              transform: translateX(-50%);
            }
          }
        }
      }
    }

  }
  .appWrapper {
    width: 100%;
    max-width: 520px;
    height: 100%;
    z-index: 9;

    .appInner::-webkit-scrollbar {
      display: none;
    }

    .appInner {
      height: 100%;
      box-sizing: border-box;
      overflow: hidden auto;
    }
  }
  .contenst {
    //max-width: 425px;
    margin: 0 auto;
    min-height: 655px;
    padding-top:70px;
    background-color: $white;
    .wrapper{
      overflow: hidden;
    }
    
  }
  @media screen and (max-width: $lg-breakpoint) {
    .app {
      .appCont {
        //max-width: 425px;
        .web_chorock {
          display: none;
        }
        .appWrapper {
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
  @media screen and (min-width: $lg-breakpoint){
    .web_familySite {
      display:block;
      height: 70px;
      line-height: 70px;
      padding: 0 60px;
      background-color: $midBlack;
      position: relative;
      z-index: 1;
      nav {
        display: flex;
        li {
          padding-left: 20px;
          font-size: $font-size-13;
          color: $white;
          a.router-link-exact-active {
            font-weight: 700;
            border-bottom: 1px solid $white;
          }
        }
        li:first-child{
          padding-left: 0;
        } 
        li:last-child{
          padding-right: 0;
        }
      }
    }

  }
</style>
